import { defineComponent as _defineComponent } from 'vue'
import ListBlock from 'ah-common-lib/src/common/components/listing/ListBlock.vue';
import OutstandingFeesFilters from './OutstandingFeesFilters.vue';
import OutstandingFeesListing from './OutstandingFeesListing.vue';
import ListDownloadButton from 'ah-common-lib/src/common/components/listing/ListDownloadButton.vue';
import { AuthorityType, ExportListType } from 'ah-api-gateways';
import { outstandingFeesTableFields } from './tableFields/outstandingFeeTableFields';
import { ref, computed } from 'vue';
import { useAhTradesState } from '../..';
import { RequestState } from 'ah-requests';


export default /*#__PURE__*/_defineComponent({
  __name: 'OutstandingFeesBlock',
  props: {
  exportOutside: {
    type: [String, Boolean],
    required: false,
    default: false,
  },
},
  setup(__props) {

const props = __props;



const outstandingFeesListing = ref<InstanceType<typeof OutstandingFeesListing> | null>(null);

// Automatically syncronised via .sync
const dataDownloadState = ref<RequestState>('idle');

const tradeState = useAhTradesState();

function downloadList(format: ExportListType) {
  outstandingFeesListing.value?.downloadData(format);
}

const showExportOutside = computed(() => props.exportOutside !== false);

const canSeeExport = computed(() =>
  tradeState.store.useAuthStore().hasAuthorities(AuthorityType.EXPORT_OUTSTANDING_FEE_REPORT)
);

return { __sfc: true,props, outstandingFeesListing, dataDownloadState, tradeState, downloadList, showExportOutside, canSeeExport, ListBlock, OutstandingFeesFilters, OutstandingFeesListing, ListDownloadButton, outstandingFeesTableFields }
}

})